"use client";

import { usePathname } from "next/navigation";
import { useEffect } from "react";


//#region [Component]
export default function GTM404Reporter() {
    const pathname = usePathname();
    useEffect(() => {
        window?.dataLayer?.push({
            event: "ERROR",
            eventCategory: "404 - Not Found"
        });
    }, [pathname]);
    return null;
}
//#endregion